import router from './router'
import store from './store'
import utils from './utils/utils'
import secret from './utils/secret'
import { getToken, getUserToken } from '@/utils/cookies'
import { removeLocalOrderProsData } from '@/utils/storage'
import { GetUserInfo } from './store/modules/user'
// 不需要删除缓存的路由
const unWantedRemoveLocalData = {
  account: '/account'
}

// const prodEnv = process.env.NODE_ENV
const CBZX_PLATFORM_PATH = process.env.CBZX_PLATFORM_PATH
// const SZTS_PLATFORM_PATH = 'https://szts.cabplink.com'
const SSO_WEB_URL = process.env.SSO_WEB_URL
const READ_PLATFORM_PATH = process.env.READ_PLATFORM_PATH

router.beforeEach((to, from, next) => {
  console.log('111112',to.matched)
  if (to.matched.length === 0) {
    next()
  } else {
    const toPath = to.path // 跳转路由
    const toMeta = to.meta // 跳转路由信息
    let requireAuth = toMeta.requireAuth // 是否需要登录
    let jumpAuth = toMeta.jumpAuth // 是否个人中心跳转
    // console.log(jumpAuth)
    // const isLogin = store.getters.isLogin
    const isLogin =JSON.parse( window.localStorage.getItem('SET_ISLOGIN'))
    const token = getUserToken() // 游客token
    const userToken = getUserToken() // 登录用户token

    let existToken = utils.isNotEmpty(userToken) // 存在游客token
    
    // 导航栏选中
    // navToolbarChecked(toPath)
    // ------------------ 处理重定向路径-start
    let targetUrl = SSO_WEB_URL + toPath
    console.log('targetUrl111',targetUrl) 
    let existUserToken  ;
    let paramsRedirectUrl = 'redirectUrl=' + secret.encryptionText(CBZX_PLATFORM_PATH + from.fullPath)
    let params = '?' + paramsRedirectUrl // 回调路径参数
    console.log("paramsRedirectUrl", paramsRedirectUrl)
    let targetFullUrl = (isLogin && jumpAuth) ? targetUrl : targetUrl + params
    console.log('targetFullUrl222',targetFullUrl)
    let thePath;
    if(/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
      thePath = '/mobileLogin'
    } else {
      thePath = '/login'
    }
    if(to.path === thePath){
        window.location.href = targetFullUrl
    }
    console.log(requireAuth,isLogin);
    
    if(requireAuth&&!isLogin){
      window.location.href = `${SSO_WEB_URL}${thePath}${params}`
    }
    console.log('existToken',existToken)

      if (existToken) { // 存在游客token
        // console.log("targetFullUrl",targetFullUrl);
        store.dispatch('GetUserInfo').then(res => {
          existUserToken =  res.data; // 存在登录用户token
          console.log("需要登录");
          if (existUserToken) { // 存在登录token
            // console.log("存在登录token");
            if (jumpAuth) {
              console.log("jumpAuth错误");
              window.location.href = targetFullUrl
              // console.log(targetFullUrl)
            } else {
              // console.log("jumpAuth正确");
              next()
              // store.dispatch('GetUserInfo').then(res => {
              //   next()
              // }).catch(() => {
              // })
            }
          } else { // 不存在登录token
            console.log("不存在登录token");
            window.location.href = targetFullUrl
          }

          // 大数据-----猜你喜欢
          // console.log('res.data.errorInfo',res.data.errorInfo)
          // if(res.data.errorInfo == 'success'){
          //   try{ 
          //     window["_BFD"] = window["_BFD"] || {}; 
          //     _BFD.USER_INFO = {  
          
          //       "cid" : "Ccabp",          //客户标识，实施人员提供 
          //       "appkey" : "b120faefdb4b97bc4db45db67f22050a",         //应用标识，实施人员提供 
          //       "pv_type" : "0",             //页面埋点方式，0 为自动发送，1 为手动调用 
          //       "pos" : true,                //是否启用鼠标点击事件，值为 true/false 
          //       "link" : true,               //是否启用链接点击事件，值为 true/false 
          //       "title" : "",                //当前页面标题，若此处不回传默认获取 document.title 
          //       "openID" : "",               //站点在微信加载时，需回传 openID，否则不用做处理 
          //       "phone_number" : res.data.data.zaUserInfoDto.mobile,         //手机号码，未登录时回传空字符串 
          //       "uid" : res.data.data.zaUserInfoDto.id             //用户 id，未登录时回传空字符串
          //     }; 
          //     // console.log('this.recommendList5',_BFD.USER_INFO)
          //     _BFD.script = document.createElement("script"); 
          //     _BFD.script.async = true; 
          //     _BFD.script.charset = "utf-8"; 
          //     _BFD.script.src=('https://data.cabplink.com/js/web.js'); // js 代码路径，由实施人员提供 
          //     document.getElementsByTagName("head")[0].appendChild(_BFD.script);
          //     }catch(e){ 
          //     } 
          // }else{
          //   try{ 
          //     window["_BFD"] = window["_BFD"] || {}; 
          //     _BFD.USER_INFO = {  
          
          //       "cid" : "Ccabp",          //客户标识，实施人员提供 
          //       "appkey" : "b120faefdb4b97bc4db45db67f22050a",         //应用标识，实施人员提供 
          //       "pv_type" : "0",             //页面埋点方式，0 为自动发送，1 为手动调用 
          //       "pos" : true,                //是否启用鼠标点击事件，值为 true/false 
          //       "link" : true,               //是否启用链接点击事件，值为 true/false 
          //       "title" : "",                //当前页面标题，若此处不回传默认获取 document.title 
          //       "openID" : "",               //站点在微信加载时，需回传 openID，否则不用做处理 
          //       "phone_number" : " ",         //手机号码，未登录时回传空字符串 
          //       "uid" : " "           //用户 id，未登录时回传空字符串
          //     }; 
          //     // console.log('this.recommendList5',_BFD.USER_INFO)
          //     _BFD.script = document.createElement("script"); 
          //     _BFD.script.async = true; 
          //     _BFD.script.charset = "utf-8"; 
          //     _BFD.script.src=('https://data.cabplink.com/js/web.js'); // js 代码路径，由实施人员提供 
          //     document.getElementsByTagName("head")[0].appendChild(_BFD.script);
          //     }catch(e){ 
          //     } 
          // }


        })
        
      } else { // 获取游客token
        console.log("获取游客token");
        store.dispatch('findToken').then(res => {
          next()
        })
      }
  
    // ------------------ 处理登录数据信息 - end
    // next()
  }
})

try{ 
  
  }catch(e){ 
  } 

router.beforeResolve((to, from, next) => {
  next()
})

/** 路由离开 */
router.afterEach((to, from) => {
  if (to.path !== unWantedRemoveLocalData.account) {
    // removeLocalOrderProsData()
  }
})

/** 导航栏选中 */
// function navToolbarChecked (path) {
//    if (path === '/index') {
//     store.commit('SET_ISACTIVE', 0)
//   } else if (path === '/xszt') {
//     store.commit('SET_ISACTIVE', 1)
//   } else if (path === '/zxsc') {
//     store.commit('SET_ISACTIVE', 2)
//   } else if (path === '/zxkc') {
//     store.commit('SET_ISACTIVE', 3)
//   } else if (path === '/hyfw') {
//     store.commit('SET_ISACTIVE', 4)
//   }  else if (path === '/personalHome') {
//     store.commit('SET_ISACTIVE', 5)
//   } 
// }


// WEBPACK FOOTER //
// ./src/permission.js